"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
const React = require("react");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const theme_1 = require("../modules/theme");
const react_native_1 = require("react-native");
const browser_1 = require("../modules/browser");
const CheckBox_1 = require("./CheckBox");
class Table extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            leftHeader: 0
        };
        this.renderHeaderTable = (headerData) => {
            const { onSelectAll, data, nativeID } = this.props;
            const { leftHeader } = this.state;
            return (React.createElement("div", { style: {
                    overflow: 'hidden',
                    position: 'relative',
                    height: 45
                } },
                React.createElement("div", { style: {
                        flexDirection: 'row',
                        alignItems: 'center',
                        paddingBottom: 8,
                        minHeight: 45,
                        position: 'absolute',
                        left: leftHeader,
                        display: 'flex',
                        paddingTop: (0, browser_1.ehIE)() ? 15 : 0
                    } }, headerData.map((column, index) => {
                    const headerId = nativeID && `${nativeID}-header-${index + 1}`;
                    return column.type === 'checkbox' ? (React.createElement(CheckBox_1.CheckBox, { nativeID: headerId, key: column.key, style: { marginLeft: 8 }, value: data.every(x => x.selected) || false, onChange: value => onSelectAll && onSelectAll(value) })) : (React.createElement(react_native_1.Text, { nativeID: headerId, key: column.key, style: [
                            styles.cell,
                            styles.cellHeader,
                            column.style,
                            column.headerStyle
                        ] }, column.title));
                }))));
        };
        this.renderDataTable = () => {
            const { columns, data, idAttribute, cellStyle, heightContainer, subHeaderData, onSelect, nativeID } = this.props;
            const height = subHeaderData ? heightContainer - 45 : heightContainer;
            return (React.createElement("div", { style: {
                    height,
                    display: 'flex',
                    overflowX: 'scroll',
                    overflowY: 'scroll'
                }, onScroll: (event) => {
                    this.setState({ leftHeader: event ? -event.target.scrollLeft : 0 });
                } },
                React.createElement("div", null,
                    React.createElement(react_native_1.FlatList, { data: data, keyExtractor: item => item.id.toString(), renderItem: ({ item, index }) => (React.createElement(react_native_1.View, { key: index, style: [
                                styles.row,
                                {
                                    backgroundColor: index % 2 === 0
                                        ? theme.backgroundColor2
                                        : theme.backgroundColor1
                                }
                            ] }, columns.map((column, columnIndex) => {
                            const style = cellStyle &&
                                cellStyle[item[idAttribute].toString()] &&
                                cellStyle[item[idAttribute].toString()][column.key];
                            const cellID = nativeID && `${nativeID}-${index + 1}-${columnIndex + 1}`;
                            return column.type === 'icon' ? (React.createElement(FontAwesome_1.default, { nativeID: cellID, key: column.key, name: item[column.key].toString(), 
                                // @ts-ignore : The component uses a different version of typing
                                style: [styles.cellIcon, style, column.style] })) : column.type === 'checkbox' ? (React.createElement(CheckBox_1.CheckBox, { nativeID: cellID, key: column.key, style: { marginLeft: 8 }, value: item.selected || false, onChange: value => onSelect && onSelect(item[column.key].toString(), value) })) : (React.createElement(react_native_1.Text, { nativeID: cellID, key: column.key, style: [styles.cell, style, column.style] }, item[column.key].toString()));
                        }))) }))));
        };
    }
    render() {
        const { columns, nativeID, subHeaderData } = this.props;
        return (React.createElement(react_native_1.View, { nativeID: nativeID },
            this.renderHeaderTable(columns),
            subHeaderData && this.renderHeaderTable(subHeaderData),
            this.renderDataTable()));
    }
}
exports.Table = Table;
Table.defaultProps = {
    //Top = 60px, padding = 16px, filters = 143px, padding = 16px, header = 45px, padding = 16
    heightContainer: react_native_1.Dimensions.get('window').height - 296
};
const theme = (0, theme_1.getTheme)();
const styles = react_native_1.StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 8,
        minHeight: 45
    },
    cell: {
        fontFamily: theme.fontFamily2,
        fontSize: 14,
        marginLeft: 8,
        lineHeight: 18,
        color: theme.textColor1
    },
    cellHeader: {
        fontFamily: theme.fontFamily1,
        color: theme.textColor1
    },
    cellIcon: {
        fontSize: 24,
        marginLeft: 8,
        textAlign: 'center',
        textAlignVertical: 'center'
    }
});
